import { makeGetRequest } from 'lib/axios';

export type SclaApplicationSummary = {
  _id: string;
  cohortYear: string | null;
  appType: 'lil' | 'scla-applicant' | 'txter' | null;
  appStatus: string | null;
  submissionTimestamp: string | null;
  sectionsComplete: number;
};

const listSclaApplications = async (): Promise<SclaApplicationSummary[]> => {
  const response = await makeGetRequest('/scla/applications');
  return response.data.payload;
};

export default listSclaApplications;
